import Core from '@/core/module';
import Dropzone from 'dropzone';
import Template from './template.html'

export default class Fileupload extends Core {
    init() {
        if(this.$el.attr('type') != 'file') {
            console.error('input for fileupload is not a file type!');
            return;
        }

        const $template = $(Template({
            tv: {
                name: this.options.name,
                url: this.options.url,
                placeholder: this.options.placeholder || 'Bestand selecteren'
            }
        }));

        this.$el.replaceWith($template);
        this.$el = $template;

        this.addDropzone();
        this.addEventListeners();
    }

    addDropzone() {
        this.$el.addClass('file--hasdropzone');

        this.$el.on('click', '.fileupload__dropzone', () => {
            $(`[data-inputname="${this.options.name}"]`).remove();
        })

        this.dropzone = new Dropzone(this.$el.find('.fileupload__dropzone')[0], {
            url: this.options.url,
            addedfile: (file) => {
                this.trigger('startUpload');
                this.$el.addClass('fileupload--uploading');
            },
            complete: (response) => {
                this.trigger('endUpload');

                try {
                    const result = JSON.parse(response.xhr.responseText);

                    if(result.success) {   
                        this.$el.find('[filename]').text(result.filename);    
                        this.$el.find('input').val(result.fileurl);     

                        this.dropzone.destroy();   

                        this.$el.addClass('file--hasfile');
                        this.$el.removeClass('file--hasdropzone');  
                        this.$el.removeClass('fileupload--uploading');   
                    }
                    else {
                        this.$el.removeClass('file--hasdropzone file--hasfile fileupload--uploading');
                        this.$el.closest('form').find(`[data-errorgroup~="${this.options.name}"]`).show().append(`<li data-inputname="${this.options.name}">${result.message}</li>`);
                    }
                }
                catch(e) {
                    this.trigger('endUpload');

                    this.$el.removeClass('file--hasdropzone file--hasfile fileupload--uploading');  

                    alert(`Er is een fout opgetreden! ${e}`);
                }
            },
            error: (errorMessage) => {
                this.trigger('endUpload');

                this.$el.removeClass('file--hasdropzone file--hasfile fileupload--uploading');  

                alert(`Er is een fout opgetreden! ${errorMessage.status}`);
            }
        });
    }

    addEventListeners() {
        this.$el.on('click', '[delete]', () => {
            this.$el.find('[filename]').text('');    
            this.$el.find('input').val('');   

            this.$el.removeClass('file--hasfile');

            this.addDropzone();
        });
    }    
}